import { PublicPageTemplate } from "./PublicPageTemplate";

const AteliersPage = () => (
  <PublicPageTemplate
    badge="Ateliers"
    title="Ateliers pratiques"
    highlight="IA appliquée"
    description="Des ateliers hands-on pour apprendre à utiliser concrètement l'IA dans votre métier, avec des cas d'usage réels."
  />
);
export default AteliersPage;
